// ============================================================================
// view.processingCutSheet — migrated off the global read
// ============================================================================
// The cut-sheet editor at /processing/cut-sheet/<recordId>. It declares
// get_processing_cut_sheet: the record, the sheet head and the candidate list
// arrive in one envelope, so the editor's opening state is a single read rather
// than three that can disagree about which trip is being edited.
//
// ONE FILE PER MIGRATED SURFACE, deliberately. This used to be one entry in a
// central MIGRATED map inside surfaceDataManifest.ts, which meant every
// concurrent localization edited the same object and collided. Discovery is now
// an eager glob over this directory, so two surfaces migrating at once touch
// two different files.
//
// This surface is NEW rather than displaced: it has no legacy reads to retire,
// because nothing rendered a cut sheet before. That is why `residualLegacy` is
// empty and why no entry moves to `retired` in render-read-sites.json — there
// is no prior physical read to move. The receipt in
// tests/fixtures/migrated-surface-receipts/view.processingCutSheet.json is the
// independent record that this declaration and its catalog resource were
// introduced together.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.processingCutSheet',
  obligations: Object.freeze([Object.freeze({id: 'processing.cutSheet.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
